import {Injectable} from '@angular/core';
import {BehaviorSubject,  Observable} from 'rxjs';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { AuthService } from '../../services/auth.service';

@Injectable()
export class TicketDialogService {
  private readonly urlBase = '/api/';
  private readonly urlMail = '/mail/';

  constructor (private httpClient: HttpClient) {}


  sendMail(data): Observable<any>{
    return this.httpClient.post<any>(this.urlMail + 'send', data);
  }

  getEmailsCC(): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'getEmailsCC');
  }

  getTicketInfo(transaction): Observable<any>{
    return this.httpClient.get<any>(this.urlBase + 'getTicketInfo?transaction=' + transaction);
  }

  applyPayment(data): Observable<any>{
    return this.httpClient.post<any>(this.urlBase + 'applyPayment', data);
  }
}
